export const intersectionObserverInit: IntersectionObserverInit = {
  rootMargin: '0px',
  threshold: 0.2,
};
